/**
 * Validates and returns the config from Secrets Manager.
 * The backend already merges globals + app-specific configs, so this function
 * primarily validates the structure and logs for debugging.
 *
 * @param secretsConfig - The config returned from Secrets Manager endpoint
 * @param appName - The application name (for logging)
 * @returns The config object (already merged by backend)
 */
export function ensureMergedStructure(secretsConfig, appName) {
    // Validate that we received a config object
    if (!secretsConfig || typeof secretsConfig !== 'object') {
        console.error('❌ Invalid config received from Secrets Manager:', secretsConfig);
        return {};
    }
    // Backend already returns merged config in flat format
    // Just validate it has expected keys and return as-is
    const hasExpectedKeys = secretsConfig.environment ||
        secretsConfig.launchDarkly ||
        secretsConfig.api ||
        secretsConfig.newRelic;
    if (hasExpectedKeys) {
        console.log(`✅ Config received for ${appName} - already merged by backend`);
        console.log('🚀🚀 -- Config keys:', Object.keys(secretsConfig).slice(0, 10).join(', '), '...');
        return secretsConfig;
    }
    // Log warning if config structure is unexpected (shouldn't happen with current backend)
    console.warn('⚠️ Config structure may be incomplete:', Object.keys(secretsConfig));
    return secretsConfig;
}
//# sourceMappingURL=config-structure-handler.util.js.map